import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import Loading from "../components_root/loading";
import Error_page from './error';
import Home_page from "../dashboard_root/home";
import Services from '../services_root/services'; 
import Product_view from '../view_root/product_view';
import Cookies from "js-cookie";
import Download_receipt from '../home_root/download-receipt';
import Accounting from '../accounting_root/accounting'; 
export default function Idpage() {
  const { id } = useParams(); // this will now be your slug
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [vouchersdata, setVouchersdata] = useState(null);
  const [productdata, setProductdata] = useState(null);
  const [downloadreceiptdata, setDownloadreceiptdata] = useState(null);
  useEffect(() => {
    let cancelled = false;

    const fetchData = async () => {
      setLoading(true);
      setError(false);
      setProductdata(null);
      setVouchersdata(null);
      setDownloadreceiptdata(null);
      try {
        const select_company_uid = Cookies.get("select_company_uid");

        // Try vouchers first only if company uid is available
        if (select_company_uid) {
          // const vouchersRef = collection(db, "accountingfinancedb", select_company_uid, "vouchers");
          // const vouchersQuery = query(vouchersRef, where("voucherid", "==", id));
          // const snapshot = await getDocs(vouchersQuery);

          // if (!snapshot.empty) {
          //   const doc = snapshot.docs[0];
          //   if (!cancelled) {
          //     setVouchersdata({ ...doc.data(), uid: doc.id });
          //   }
          //   return; // found voucher, stop further lookup
          // }
          //setDownloadreceiptdata
           const DownloadRef = collection(db, "accountingfinancedb", select_company_uid, "voucher_print");
          const DownloadQuery = query(DownloadRef, where("slug", "==", id));
          const Downloadsnapshot = await getDocs(DownloadQuery);

          if (!Downloadsnapshot.empty) {
            const doc = Downloadsnapshot.docs[0];
            if (!cancelled) {
              setDownloadreceiptdata({ ...doc.data(), uid: doc.id });
            }
            return; // found voucher, stop further lookup
          }
        }

        // Product (use slug)
        const productSnap = await getDocs(
          query(collection(db, "products"), where("slug", "==", id))
        );

        if (!productSnap.empty) {
          if (!cancelled) {
            setProductdata({ ...productSnap.docs[0].data(), uid: productSnap.docs[0].id });
          }
          return;
        }

        // If neither found
        if (!cancelled) setError(true);
      } catch (err) {
        console.error("Error fetching data for Idpage:", err);
        if (!cancelled) setError(true);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    if (id) {
      fetchData();
    } else {
      // no id param -> show home (clear loading)
      setLoading(false);
      setError(false);
      setVouchersdata(null);
      setProductdata(null);
    }

    return () => {
      cancelled = true;
    };
  }, [id]);

  if (loading) return <div className="container_roots"><Loading /></div>;
  // if (vouchersdata) return <Voucher_print data={vouchersdata} />;
    if (downloadreceiptdata) return <Download_receipt data={downloadreceiptdata} />;
  if (productdata) return <Product_view data={productdata} />;
  if (error) return <Error_page />; 
 return <Accounting />;
   
}